import Debug from 'debug';

const CONFIG_KEYS = [
  'gossamer-be-origin',
  'gossamer-fe-origin',
  'gossamer-api-path',
  'main-fe-origin',
  'bs-theme',
  'built-at',
  'login-bypass',
  'org-path',
  'role-id',
  'user-id',
  'generic-mode',
  'session-token-frontend-domain',
  'stripe-publishable-key',
  'livekit-ws-url',
] as const;
export type ConfigKey = (typeof CONFIG_KEYS)[number];

const debug = Debug('gfe/an/ConfigManager');

const values: Partial<Record<ConfigKey, string>> = {};

CONFIG_KEYS.forEach((key) => {
  const overrideValue = localStorage.getItem(key);
  if (overrideValue) {
    values[key] = overrideValue;
  }
});

debug(values);

export const getConfig = (key: ConfigKey) => values[key];

export const getConfigOrThrow = (key: ConfigKey) => {
  if (!values[key]) {
    throw new Error(`config key '${key}' is not set`);
  }
  return values[key];
};

export const setConfig = (key: ConfigKey, value: string | undefined) => {
  values[key] = value;
};

export const displayConfig = () => CONFIG_KEYS.forEach((key) => console.log(key + ' = ' + values[key]));

if (typeof window !== 'undefined' && !!getConfig('bs-theme')) {
  window.document.querySelector('html')?.setAttribute('data-bs-theme', getConfig('bs-theme') as string);
}
